const getUserName = (state, getters) => {
  if (state.user !== null) {
    return state.user.name
  } else {
    return null
  }
}

const getUserBooks = state => {
  return state.user && state.user.books
}

export default {
  getUserName,
  getUserBooks
}
